export const minimumWithdraw = 1
export const minimumWithdrawWithoutAdminFee = 50000
